import React, { useContext, useEffect, useState, useRef } from "react";
import "./style.css";
import { WindowSizeContext } from "../../context/WindowSizeContext";

const getRandom = (min, max) => Math.random() * (max - min) + min;

const Particle = ({ vWidth }) => {
  const particleRef = useRef(null);

  useEffect(() => {
    const createParticle = () => {
      const particle = document.createElement("div");
      particle.classList.add("particle");
      document.querySelector(".particle-container").appendChild(particle);
      particleRef.current = particle;

      const size = getRandom(1, 7);
      const startX = getRandom(0, vWidth - size - 20);
      const duration = getRandom(5, 10);

      particle.style.width = `${size}px`;
      particle.style.height = `${size}px`;
      particle.style.left = `${startX}px`;
      particle.style.bottom = `-${size}px`;
      particle.style.background = `rgba(255, 255, 255, ${getRandom(0.1, 0.6)})`;
      particle.style.animationDuration = `${duration}s`;

      particle.addEventListener("animationend", () => {
        particle.remove();
        createParticle();
      });
    };

    createParticle();

    return () => {
      const particles = document.querySelectorAll(".particle");
      particles.forEach((particle) => particle.remove());
    };
  }, [vWidth]);

  useEffect(() => {
    const particle = particleRef.current;
    if (particle) {
      const size = parseFloat(particle.style.width);
      const startX = getRandom(0, vWidth - size - 20);
      particle.style.left = `${startX}px`;
    }
  }, [vWidth]);

  return null;
};

export default function UniversalParticulas({
  children,
  className,
  vIsModal = false,
}) {
  const { width, height } = useContext(WindowSizeContext);
  const [vWidth, setVWidth] = useState(width - 20);

  useEffect(() => {
    setVWidth(width - 20);
  }, [width]);

  useEffect(() => {
    const handleResize = () => {
      setVWidth(window.innerWidth - 20);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section
      className={`particle-container ${className ? className : ""}`}
      style={!vIsModal ? { width: vWidth } : {  height: height}}
    >
      {Array.from({ length: 100 }).map((_, index) => (
        <Particle key={index} vWidth={vWidth} />
      ))}
      {children}
    </section>
  );
}
